function u(o, s) {
  if (s === 0) return o;
  let e;
  return (...i) => (e || (e = {}, e.promise = new Promise((t, r) => {
    e.resolve = t, e.reject = r;
  })), clearTimeout(e.timeout), e.latestArgs = i, e.timeout = setTimeout(() => {
    const t = e;
    e = void 0;
    try {
      t.resolve(o(...t.latestArgs));
    } catch (r) {
      t.reject(r);
    }
  }, s), e.promise);
}
export {
  u as debounce
};
